import { useState, useEffect, forwardRef, useImperativeHandle } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { Container, TextInput, Select, Button, Text} from '@mantine/core';
import { useForm } from "@mantine/form";
import { IconAt,IconSend, IconCheck } from '@tabler/icons-react';
import { Row, Col } from 'react-bootstrap';
import PhoneInputGroup from '../components/PhoneInputGroup';
import ModalSMSVerification from "../components/ModalSMSVerification";
import ModalMailVerification from "../components/ModalMailVerification";
import { SaveResponses } from "../actions/ResponsesActions";
import { useDebouncedValue } from "@mantine/hooks";
import CellPhoneCountrys from '../enums/CellPhoneCountrys';
import { GetConocio, GetPaises, GetEligio, GetProvincias, SendSMS, verifyCodeSMS,sendMailValidation,verifyMailValidation } from "../actions/FormDataActions";
import { stepIds } from '../enums/fieldsDataConfig';
import { useStepResponses } from "../hooks/useStepResponses";
import useFormTracking, { identifyUser } from "../hooks/useFormTracking";
const ContactDataForm = forwardRef(({ stepNumber, id,queryparams }, ref) => {
  
  const dispatch = useDispatch();
  const personalResponse = useStepResponses(stepIds.PERSONA);
  const response = useSelector((state) => state.respuestas.steps[stepNumber]?.responses || {});
  const {data: dataConocio} = useSelector((state) => state.datosFormulario.conocio);
  const {data: dataPaises} = useSelector((state) => state.datosFormulario.paises);
  const {data: dataProvincias} = useSelector((state) => state.datosFormulario.provincias);
  const {data: dataEligio} = useSelector((state) => state.datosFormulario.eligio);

  //const [smsSent, setSmsSent] = useState(false);
  const [smsVerified, setSmsVerified] = useState(false);
  const [mailVerified, setMailVerified] = useState(false);
  const [verificationCode, setVerificationCode] = useState('');
  const [verificationError, setVerificationError] = useState(false);
  const [sendingVerificationCode, setSendingVerificationCode] = useState(false);
  const [timer, setTimer] = useState(0);

  const [modalOpened, setModalOpened] = useState(false);

  const { track } = useFormTracking(stepNumber);
  const trackSelect = (fieldName) => (value) => {
    form.setFieldValue(fieldName, value);
    if (value) track('field_completed', { fieldName });
  };

  const trackOnBlur = (fieldName) => () => {
    if (form.values[fieldName]) track('field_completed', { fieldName });
  };

  const [modalOpenedMail, setModalOpenedMail] = useState(false);
  const [verificationCodeMail, setVerificationCodeMail] = useState('');
const [sendingVerificationCodeMail, setSendingVerificationCodeMail] = useState(false);
const [verificationErrorMail, setVerificationErrorMail] = useState(false);
const [timerMail, setTimerMail] = useState(0);

  const form = useForm({
    initialValues: {
      email: response.email || '',
      emailConfirmacion: response.emailConfirmacion || '',
      calle: response.calle || '',
      altura: response.altura || '',
      piso: response.piso || '',
      departamento: response.departamento || '',
      codPostal: response.codPostal || '',
      localidad: response.localidad || '',
      paisResidencia: response.paisResidencia || 'AR',
      provincia: response.provincia || 'BAI',
      provinciaDescripcion: response.provinciaDescripcion || '',
      codAreaParticular: response.codAreaParticular || '+54',
      telefonoParticular: response.telefonoParticular || '',
      codAreaCelular: response.codAreaCelular || '+54',
      telefonoCelular: response.telefonoCelular || '',
      conocioInstitucion: response.conocioInstitucion || null,
      eligioInstitucion: response.eligioInstitucion || null,
      smsVerified: response.smsVerified || false,
      mailVerified: response.mailVerified || false,
    },
    validate: {
      email: (value) => {
        if(/^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(value) ? null : "El email no es válido");
        if (!form.values.mailVerified) return "Debe verificar su mail";
      },
      telefonoCelular: (value) => {
        const cleaned = value.replace(/\s+/g, "");
        if (!/^\d{10,14}$/.test(cleaned)) return "Debe tener entre 10 y 14 dígitos numéricos";
        if (cleaned.startsWith("0")) return "No debe comenzar con 0";
       // if (!form.values.smsVerified) return "Debe verificar el número con SMS";
        return null;
      },
      calle: (value) => (value?.length > 2 ? null : "El campo es obligatorio"),
      altura: (value) => (value?.length > 0 ? null : "El campo es obligatorio"),
      codPostal: (value) => (value?.length > 2 ? null : "El campo es obligatorio"),
      localidad: (value) => (value?.length > 2 ? null : "El campo es obligatorio"),
      paisResidencia: (value) => (value ? null : "El campo es obligatorio"),
      provincia: (value) => (value ? null : "El campo es obligatorio"),
      codAreaCelular: (value) => (value ? null : "El campo es obligatorio"),
      eligioInstitucion: (value) => (value ? null : "El campo es obligatorio"),
    },
  });
  const [debouncedValues] = useDebouncedValue(form.values, 300);
  
  useEffect(() => {
    const currentMailVerified = form.values.mailVerified;
    const currentSmsVerified = form.values.smsVerified;
    dispatch(SaveResponses(id, {
      ...debouncedValues,
      smsVerified: currentSmsVerified,
      mailVerified: currentMailVerified
    }));
  }, [debouncedValues, dispatch, id]);

  useEffect(() => {
    if (response) {
      if (response.mailVerified) {
        setMailVerified(true);
        form.setFieldValue('mailVerified', true);
      }
      if (response.smsVerified) {
        setSmsVerified(true);
        form.setFieldValue('smsVerified', true);
      }
    }
  }, [response]);

  useEffect(() => {
    dispatch(GetConocio());
    dispatch(GetPaises());
    dispatch(GetEligio());
    dispatch(GetProvincias());
  }, []);


  useImperativeHandle(ref, () => ({
    validate: () => {
      const validation = form.validate();
      if (validation.hasErrors) {
        Object.keys(validation.errors).forEach((field) =>
          track('field_error', { fieldName: field })
        );
        return false;
      }
      return true;
    },
  }));

  useEffect(() => {
    if (timer > 0) {
      const interval = setInterval(() => {
        setTimer(timer - 1);
      }, 1000);
      return () => clearInterval(interval);
    }
  }, [timer]);

  useEffect(() => {
    if (timerMail > 0) {
      const interval = setInterval(() => {
        setTimerMail(timerMail - 1);
      }, 1000);
      return () => clearInterval(interval);
    }
  }, [timerMail]);

  const handleSaveResponse = (fieldName, value) => {
    form.setValues({ [fieldName]: value });
  };

  const handleSavePais = (pais) => {
    form.setValues({ ['paisResidencia']: pais });
    form.setValues({ ['provincia']: null });
    form.setValues({ ['provinciaDescripcion']: null });
    if (pais) track('field_completed', { fieldName: 'paisResidencia' });
  };

  const handleSaveResponseProvincia = (provincia) => {
    let prov = dataProvincias.find((p) => p.value === provincia);
    if (prov) {
      form.setValues({ ['provincia']: prov.value });
      form.setValues({ ['provinciaDescripcion']: prov.label });
    } else {
      form.setValues({ ['provincia']: 'OTR' });
      form.setValues({ ['provinciaDescripcion']: provincia });
    }
    if (provincia) track('field_completed', { fieldName: 'provincia' });
  };

  const handleSendSMS = () => {
    if(timer>0){
      setModalOpened(true);
    }else{
      setSendingVerificationCode(true);
      dispatch(SendSMS(personalResponse.nombres+personalResponse.apellidos, form.values.codAreaCelular+form.values.telefonoCelular)).then(() => {
        setSendingVerificationCode(false);
        setTimer(100);
        setModalOpened(true);
        track('field_completed', { fieldName: 'sms_code_sent' });
      });
    }
    
  };

  const handleVerifyCode = (code) => {
    dispatch(verifyCodeSMS(personalResponse.nombres+personalResponse.apellidos, form.values.codAreaCelular+form.values.telefonoCelular, code)).then((isValid) => {
      if (isValid) {
        //setSmsVerified(true);
        setModalOpened(false);
        setVerificationError(false);
        track('field_completed', { fieldName: 'sms_verified' });
        dispatch(SaveResponses(id, {
          ...form.values,
          smsVerified: true
        }));
      } else {
        //setSmsVerified(false);
        setVerificationError(true);
        track('field_error', { fieldName: 'sms_verified' });
      }
    });
  };


  const handleSendMail = () => {
    if(timerMail>0){
      setModalOpenedMail(true);
    }else{
      setSendingVerificationCodeMail(true);
      dispatch(sendMailValidation(form.values.email)).then(() => {
        setSendingVerificationCodeMail(false);
        setTimerMail(100);
        setModalOpenedMail(true);
        track('field_completed', { fieldName: 'mail_code_sent' });
      });
    }
    
  };

  const handleVerifyCodeMail = (code) => {
    dispatch(verifyMailValidation(form.values.email, code)).then((isValid) => {
      if (isValid) {
        setMailVerified(true);
        setModalOpenedMail(false);
        setVerificationErrorMail(false);
        track('field_completed', { fieldName: 'mail_verified' });

        identifyUser(form.values.email);

        dispatch(SaveResponses(id, {
          ...form.values,
          mailVerified: true
        }));
      } else {
        setMailVerified(false);
        setVerificationErrorMail(true);
        track('field_error', { fieldName: 'mail_verified' });
      }
    });
  };
   
   
  return (
    <Container size="100%">
      <Row className='row-inputs'>
        <Col md={6}>
          <fieldset disabled={mailVerified}>
          <TextInput
            required
            label="Email"
            placeholder='usuario@mail.com.ar'
            onPaste={(e) => e.preventDefault()}
            rightSection={<IconAt size={20} />}
            {...form.getInputProps("email")}
            onBlur={trackOnBlur('email')}
            style={mailVerified ? { borderColor: 'green' } : {}}
          />
          
          </fieldset>
        </Col>
        <Col md={6} style={{display: "flex", flexDirection: "column", justifyContent: "flex-end"  }}>
        {mailVerified && (
            <Text size="md" c="green" style={{ marginBottom: '5px' }}>
              <IconCheck size={20} color="green" style={{ marginRight: '5px' }} />
              Mail verificado
            </Text>
          )}
          {!mailVerified && (
            <>{timerMail > 0 && (
                <Text size="sm" c="red" style={{ marginTop: '5px' }}>
                  Espera {timerMail} segundos para reenviar
                </Text>
              )}
              {form.values.email?.length >= 12 && (
                
                <Button
                  leftSection={<IconSend size={20} />}
                  variant="outline"
                  color="rgb(242, 10, 95)"
                  mt={'sm'}
                  onClick={handleSendMail}
                  loading={sendingVerificationCodeMail}
                  fullWidth
                >
                  Enviar mail de confirmacion
                </Button>
              )}
              
            </>
          )}
        </Col>
      </Row>
      <Row className='row-inputs'>
        <Col md={6}>
          <Select
            required
            label="País de Residencia"
            searchable
            data={dataPaises}
            checkIconPosition="right"
            placeholder="Seleccione una opción"
            {...form.getInputProps("paisResidencia", {
              onChange: (value) => {
                handleSavePais(value);
              },
            })}
          />
        </Col>
        <Col md={6}>
          {form.values.paisResidencia === 'AR' ? (
            <Select
              required
              label="Provincia"
              placeholder="Seleccione provincia"
              data={dataProvincias}
              {...form.getInputProps("provincia", {
                onChange: (value) => {
                  handleSaveResponseProvincia(value);
                },
              })}
            />
          ) : (
            <TextInput
              required
              label="Provincia"
              placeholder="Ingrese la provincia"
              {...form.getInputProps("provinciaDescripcion", {
                onChange: (e) => {
                  handleSaveResponseProvincia(e.target.value);
                },
              })}
            />
          )}
        </Col>
        <Col md={6}>
          <TextInput
            required
            label="Localidad"
            placeholder='Vicente López'
            onPaste={(e) => e.preventDefault()}
            {...form.getInputProps("localidad")}
            onKeyDown={(event) => {
              if (!/^[a-zA-Z\sáéíóúÁÉÍÓÚñÑ]*$/.test(event.key) && event.key !== "Backspace" && event.key !== "Tab") {
                event.preventDefault();
              }
            }}
            onBlur={trackOnBlur('localidad')}
          />
        </Col>
        <Col md={6}>
          <TextInput
            required
            type="number"
            label="Codigo postal"
            placeholder='1111'
            onPaste={(e) => e.preventDefault()}
            {...form.getInputProps("codPostal")}
            onBlur={trackOnBlur('codPostal')}
          />
        </Col>
      </Row>
      <Row className='row-inputs'>
        <Col md={3}>
          <TextInput
            required
            label="Calle"
            placeholder='Av.San Juan'
            {...form.getInputProps("calle")}
            onPaste={(e) => e.preventDefault()}
            onKeyDown={(event) => {
              if (!/^[a-zA-Z0-9\sáéíóúÁÉÍÓÚñÑ]*$/.test(event.key) && event.key !== "Backspace" && event.key !== "Tab") {
                event.preventDefault();
              }
            }}
            onBlur={trackOnBlur('calle')}
          />
        </Col>
        <Col md={3}>
          <TextInput
            required
            label="Altura"
            placeholder='123'
            type="number"
            onPaste={(e) => e.preventDefault()}
            {...form.getInputProps("altura")}
            onBlur={trackOnBlur('altura')}
          />
        </Col>
        <Col md={3}>
          <TextInput
            label="Piso"
            placeholder='01'
            type="number"
            onPaste={(e) => e.preventDefault()}
            {...form.getInputProps("piso")}
            onBlur={trackOnBlur('piso')}
          />
        </Col>
        <Col md={3}>
          <TextInput
            label="Departamento"
            placeholder='Sí/No'
            onPaste={(e) => e.preventDefault()}
            {...form.getInputProps("departamento")}
            onKeyDown={(event) => {
              if (!/^[a-zA-Z\sáéíóúÁÉÍÓÚñÑ]*$/.test(event.key) && event.key !== "Backspace" && event.key !== "Tab") {
                event.preventDefault();
              }
            }}
            onBlur={trackOnBlur('departamento')}
          />
        </Col>
      </Row>
      <Row className='row-inputs'>
        <Col md={6}>

          <PhoneInputGroup
            label="Teléfono celular"
            placeholder="11 33445566"
            required
            onPaste={(e) => e.preventDefault()}
            {...form.getInputProps("telefonoCelular")}
            countryCode={form.values.codAreaCelular}
            onPhoneChange={(value) => {
              handleSaveResponse('telefonoCelular', value);
              if (/^\d{10,14}$/.test(value.replace(/\s+/g, ''))) track('field_completed', { fieldName: 'telefonoCelular' });
            }}
            onCountryChange={(value) => handleSaveResponse("codAreaCelular", value)}
            error={form.errors.telefonoCelular}
            countryOptions={CellPhoneCountrys}
            //style={smsVerified ? { borderColor: 'green' } : {}}
          />
        
        </Col>
        <Col md={6}>
          <PhoneInputGroup
            label="Teléfono particular"
            placeholder="1122 3344"
            {...form.getInputProps("telefonoParticular")}
            onPaste={(e) => e.preventDefault()}
            countryCode={form.values.codAreaParticular}
            onPhoneChange={(value) => {
              const numericValue = value.replace(/\D/g, "");
              handleSaveResponse("telefonoParticular", numericValue);
              if (/^\d{10,14}$/.test(numericValue)) track('field_completed', { fieldName: 'telefonoParticular' });
            }}
            onCountryChange={(value) => handleSaveResponse("codAreaParticular", value)}
            error={form.errors.telefonoParticular}
            countryOptions={CellPhoneCountrys}
            onKeyDown={(event) => {
              if (!/^\d$/.test(event.key) && event.key !== "Backspace" && event.key !== "Tab") {
                event.preventDefault(); // Bloquea cualquier tecla que no sea un número
              }
            }}
          />
        </Col>
      </Row>
      <Row className='row-inputs'>
        <Col md={6}>
          <Select
            required
            label="¿Cómo conoció la institución?"
            data={dataConocio?.map((conocio) => {
              const [key, value] = Object.entries(conocio)[0];
              return { value, label: conocio.vc_descripcion };
            })}
            checkIconPosition='right'
            placeholder='Eventos/Charlas'
            {...form.getInputProps("conocioInstitucion")}
            onChange={trackSelect('conocioInstitucion')}
          />
        </Col>
        <Col md={6}>
          <Select
            required
            label="¿Porque eligió la institución?"
            data={dataEligio}
            checkIconPosition='right'
            placeholder='Aranceles accesibles'
            {...form.getInputProps("eligioInstitucion")}
            onChange={trackSelect('eligioInstitucion')}
          />
        </Col>
      </Row>
      <ModalSMSVerification
        isOpen={modalOpened}
        onClose={() => setModalOpened(false)}
        phoneNumber={form.values.telefonoCelular}
        timer={timer}
        verificationCode={verificationCode}
        setVerificationCode={setVerificationCode}
        onVerify={handleVerifyCode}
        onResend={handleSendSMS}
        verificationError={verificationError}
      />
       <ModalMailVerification
        isOpen={modalOpenedMail}
        onClose={() => setModalOpenedMail(false)}
        mail={form.values.email}
        timer={timerMail}
        verificationCode={verificationCodeMail}
        setVerificationCode={setVerificationCodeMail}
        onVerify={handleVerifyCodeMail}
        onResend={handleSendMail}
        verificationError={verificationErrorMail}
      />
    </Container>
  );
});

export default ContactDataForm;



